"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doesMeetConditions = void 0;
var common_1 = require("./common");
var text_1 = require("./text");
var entity_property_1 = require("./condition-types/entity-property");
var unhandledOperation = function (operation) {
    throw new Error(text_1.errors.unhandledOperation(operation));
};
var checkOperation = function (operation, conditionsInput, staticContextInput, clientData) {
    var conditions = common_1.isObjectOrArray(conditionsInput) ? conditionsInput : {};
    var staticContext = common_1.isObject(staticContextInput) ? staticContextInput : {};
    var staticKeys = [];
    var operationEntries = [];
    var propertyConditions;
    if (Array.isArray(conditions)) {
        propertyConditions = conditions;
    }
    else {
        staticKeys = Object.keys(conditions).filter(common_1.isStaticKey);
        propertyConditions = Object.entries(conditions)
            .filter(function (_a) {
            var key = _a[0];
            return common_1.isEntityPropertyCondition(key);
        })
            .map(function (_a) {
            var _b;
            var key = _a[0], condition = _a[1];
            return (_b = {}, _b[key] = condition, _b);
        });
        operationEntries = Object.entries(conditions).filter(function (_a) {
            var key = _a[0], _ = _a[1];
            return common_1.isOperation(key);
        });
    }
    var staticKeysLength = staticKeys.length;
    var operationsLength = operationEntries.length;
    var propertyConditionsLength = propertyConditions.length;
    var staticEqualityComparator = function (key) {
        return (Array.isArray(conditions[key]) ? conditions[key] : [conditions[key]]).includes(staticContext[key]);
    };
    if (staticKeysLength === 0 && operationsLength === 0 && propertyConditionsLength === 0) {
        return common_1.Instruction.Skip;
    }
    if (staticKeysLength !== 0 || propertyConditionsLength !== 0) {
        var clientDataConditionResult = void 0;
        switch (operation) {
            case common_1.AND_OPERATION:
                if (staticKeysLength && !staticKeys.every(staticEqualityComparator)) {
                    return false;
                }
                clientDataConditionResult = entity_property_1.entityPropertyHandlers[common_1.AND_OPERATION](propertyConditions, clientData);
                if (clientDataConditionResult !== common_1.Instruction.Continue) {
                    return clientDataConditionResult;
                }
                break;
            case common_1.OR_OPERATION:
                if (staticKeysLength && staticKeys.some(staticEqualityComparator)) {
                    return true;
                }
                clientDataConditionResult = entity_property_1.entityPropertyHandlers[common_1.OR_OPERATION](propertyConditions, clientData);
                if (clientDataConditionResult !== common_1.Instruction.Continue) {
                    return clientDataConditionResult;
                }
                break;
            case common_1.NOT_OPERATION:
                if (staticKeysLength && staticKeys.some(function (key) { return !staticEqualityComparator(key); })) {
                    return true;
                }
                clientDataConditionResult = entity_property_1.entityPropertyHandlers[common_1.NOT_OPERATION](propertyConditions, clientData);
                if (clientDataConditionResult !== common_1.Instruction.Continue) {
                    return clientDataConditionResult;
                }
                break;
            default:
                return unhandledOperation(operation);
        }
    }
    for (var index = 0; index < operationEntries.length; index += 1) {
        var _a = operationEntries[index], nextOperation = _a[0], nextConditions = _a[1];
        var nextOperationResult = checkOperation(nextOperation, nextConditions, staticContext, clientData);
        if (nextOperationResult === common_1.Instruction.NeedData) {
            return nextOperationResult;
        }
        switch (operation) {
            case common_1.AND_OPERATION:
                if (nextOperationResult === false) {
                    return false;
                }
                if (nextOperationResult === common_1.Instruction.Skip && operationsLength === 1) {
                    return staticKeysLength + propertyConditionsLength === 0 ? common_1.Instruction.Skip : true;
                }
                break;
            case common_1.OR_OPERATION:
                if (nextOperationResult === true) {
                    return true;
                }
                if (nextOperationResult === common_1.Instruction.Skip && operationsLength === 1) {
                    return staticKeysLength + propertyConditionsLength === 0 ? common_1.Instruction.Skip : false;
                }
                break;
            case common_1.NOT_OPERATION:
                if (nextOperationResult === false) {
                    return true;
                }
                if (nextOperationResult === common_1.Instruction.Skip && operationsLength === 1) {
                    return staticKeysLength + propertyConditionsLength === 0 ? common_1.Instruction.Skip : false;
                }
                break;
            default:
                return unhandledOperation(operation);
        }
    }
    switch (operation) {
        case common_1.AND_OPERATION:
            return true;
        case common_1.OR_OPERATION:
            return false;
        case common_1.NOT_OPERATION:
            return false;
        default:
            return unhandledOperation(operation);
    }
};
var validateNesting = function (conditionsInput, nesting) {
    if (nesting === void 0) { nesting = 0; }
    if (nesting >= 10) {
        throw new Error(text_1.errors.nestingOvercomplicated());
    }
    var conditions = common_1.isObjectOrArray(conditionsInput) ? conditionsInput : {};
    if (Array.isArray(conditions)) {
        return;
    }
    Object.entries(conditions)
        .filter(function (_a) {
        var key = _a[0], _ = _a[1];
        return common_1.isOperation(key);
    })
        .forEach(function (_a) {
        var _ = _a[0], condition = _a[1];
        return validateNesting(condition, nesting + 1);
    });
};
exports.doesMeetConditions = function (conditions, staticContext, clientDataProvider) {
    try {
        validateNesting(conditions);
        var result_1 = checkOperation(common_1.AND_OPERATION, conditions, staticContext);
        if (result_1 !== common_1.Instruction.NeedData) {
            return result_1 === common_1.Instruction.Skip ? true : result_1;
        }
        if (!clientDataProvider) {
            return false;
        }
        return clientDataProvider
            .fetchPropertyValues(entity_property_1.collectEntityPropertiesToFetch(conditions))
            .then(function (clientData) {
            result_1 = checkOperation(common_1.AND_OPERATION, conditions, staticContext, clientData);
            return result_1 === common_1.Instruction.Skip ? true : result_1;
        })
            .catch(function () { return false; });
    }
    catch (_a) {
        return false;
    }
};
